// src/layouts/AppLayout.jsx
import { useState, useEffect, useRef } from "react";          // ← useEffect و useRef اضافه شد
import { useNavigate, useLocation } from "react-router-dom";

import Navbar1 from '../components/Navbar1';
import Navbar2 from '../components/Navbar2';
import UserSettingsDrawer from "../components/Settings/UserSettingsDrawer";




import { useGlobalPerformanceGuard } from '../hooks/useGlobalPerformanceGuard';





import './AppLayout.css';

// ============================================================
// ✅ مسیرهایی که «صفحه‌ی اول» محسوب می‌شوند (بازگشت از آن‌ها = تلاش برای خروج)
// ============================================================
const ROOT_PATHS = ['/home', '/StudentHome', '/TeacherHome', '/AdminHome', '/ParentHome'];

export default function AppLayout({ children }) {

  useGlobalPerformanceGuard();

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // ✅ پاکسازی مسیر: حذف اسلش انتهایی
  const currentPath = location.pathname.replace(/\/$/, '');
  
  // مسیرهایی که نوار بالایی دارند
  const topNavPaths = ["/home","/StudentHome","/TeacherHome","/AdminHome","/ParentHome", "/exams/student"];
  const showTopNav = topNavPaths.includes(currentPath);

  // مسیرهایی که نوار پایینی دارند
  const bottomNavPaths = ["/home","/StudentHome","/TeacherHome","/AdminHome","/ParentHome", "/exams/student", "/exams/teacher", "/PrivateClassPage", "/books" , "/private-class/admin","/private-class/student","/private-class/teacher", "/teacher/books","/admin/books","/student-lessons"];
  const showBottomNav = bottomNavPaths.includes(currentPath);

  // ============================================================
  // ✅ قابلیت «دوبار بازگشت برای خروج» — فقط در صفحه‌ی اول
  // ============================================================
  const [exitMessageVisible, setExitMessageVisible] = useState(false);
  const lastBackPressRef = useRef(0);
  const messageTimerRef = useRef(null);
  const hasPushedStateRef = useRef(false);

  const isRootPath = ROOT_PATHS.includes(currentPath);

  useEffect(() => {
    // اگر در صفحه‌ی اول نیستیم، هیچ کاری نکن
    if (!isRootPath) return;

    // اطمینان از ثبت pushState فقط یک‌بار (برای StrictMode)
    if (!hasPushedStateRef.current) {
      window.history.pushState({ __exitGuard: true }, '', window.location.href);
      hasPushedStateRef.current = true;
    }

    const handlePopState = () => {
      // اگر State ما حذف شده، دوباره ثبت کن تا در صفحه بمانیم
      window.history.pushState({ __exitGuard: true }, '', window.location.href);

      const now = Date.now();
      const timeDiff = now - lastBackPressRef.current;

      if (timeDiff < 2000 && lastBackPressRef.current !== 0) {
        // ✅ بازگشت دوم در بازه‌ی ۲ ثانیه → خروج
        setExitMessageVisible(false);
        if (messageTimerRef.current) clearTimeout(messageTimerRef.current);
        // خروج واقعی: عقب رفتن از ورودی‌های اضافی
        window.history.go(-2);
        return;
      }

      // ✅ بازگشت اول → نمایش پیام
      lastBackPressRef.current = now;
      setExitMessageVisible(true);

      if (messageTimerRef.current) clearTimeout(messageTimerRef.current);
      messageTimerRef.current = setTimeout(() => {
        setExitMessageVisible(false);
        lastBackPressRef.current = 0; // ریست تایمر
      }, 2000);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (messageTimerRef.current) clearTimeout(messageTimerRef.current);
    };
  }, [isRootPath]);

  // ============================================================
  // ✅ رندر
  // ============================================================
  return (
    <div className="app-shell">
      {showTopNav && <Navbar2 openSettings={() => setIsSettingsOpen(true)} />}
      
      <UserSettingsDrawer
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        onAvatarClick={() => navigate("/avatar-settings")}
      />

      <main className="app-content">
        {children}
      </main>

      {showBottomNav && <Navbar1 openSettings={() => setIsSettingsOpen(true)} />}

      {/* ✅ پیام «برای خروج دوباره بازگشت بزنید» */}
      {exitMessageVisible && (
        <div className="exit-guard-toast" role="alert" dir="rtl">
          برای بازگشت از برنامه، دوباره دکمه بازگشت را بزنید
        </div>
      )}
    </div>
  );
}